<div class="slot"   [ngClass]="{higlight:data.higlight,small:data.type=='s',big:data.type!=='s' }" 
[ngClass]="{higlightbooked:data.bookedhiglight,higlight:data.higlight,small:data.type=='s',big:data.type!=='s' }">
    <div class="value"  *ngIf="data.show">
      {{data.value}}
    </div>
    <div class="value" *ngIf="!data.show">
    </div>
  </div>